export default {
    "en": {
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "dapp": {
            "head_title": "{title} newest informations",
            "hot": "Hot!",
            "new": "New!",
            "hot_detail": "It will be displayed when there is a rise in the number of trades, On the basis of the transaction history of an blockchain system within 24 hours.",
            "new_detail": "Dapps that you newly started the deals within two weeks will be displayed.",
            "ranking": "Popularity Ranking.",
            "ranking_detail": "It will be displayed by a descending order on the basis of Dapp trading volume within 24 hours .",
            "rank": "rank",
            "title": "Title",
            "category": {
                "newest": "New Arrivals List",
                "all": "Article List"
            },
            "balance": "Blance",
            "lastbalance": "Blance",
            "dau": "DAU/24H",
            "lastdau": "DAU",
            "DAU": "DAU/24H",
            "twitter": "View Twitter",
            "volume_24": "Vol/day",
            "volume_7d": "Vol/7day",
            "lastvolume24": "Vol/day",
            "lastvolume7d": "Vol/7day",
            "volume": "volume",
            "transaction": "transactions",
            "transaction_1h": "Tx/1h",
            "transaction_24h": "Tx/day",
            "transaction_7d": "Tx/7day",
            "lasttransactions24h": "Tx/day",
            "lasttransactions7d": "Tx/7day",
            "max_total_volume": "Highest Player",
            "rank_title": "The standard of trading volume per day",
            "title_title": "Title",
            "category_title": "Category",
            "balance_title": "Contract Address Total ETH balance",
            "dau_title": "Total number of transactions per day",
            "volume_24_title": "Total ETH trading volume per day",
            "volume_7d_title": "Total 7-day ETH trading volume",
            "transaction_1h_title": "Total number of settlements per day",
            "transaction_1d_title": "Total number of settlements per day",
            "transaction_24h_title": "Total number of settlements per day",
            "transaction_7d_title": "Total number of settlements for 7 days",
            "remove_fav": "remove favorite.",
            "readmore": "Read More",
            "add_fav": "add favorite",
            "detail": "Detail",
            "web": "view website.",
            "dapps_count": "Apps",
            "sortby": "Sort",
            "category_dapps": "{category}",
            "status_dapps": "{status}",
            "category_dapps_d": "{category} dApps's ",
            "status_dapps_d": "{status} dApps's ",
            "index": "List of blockchaingames",
            "mydappinfo": "My Info",
            "bcgi_storategy": "Game Walkthrough Guide",
            "contractaddress": "Check ContractAddress",
            "sort": {
                "created_at": "New arrivals",
                "hotflag": "Pickup",
                "Transactions_24h": "Tx",
                "Vloume_24h": "Volume",
                "DAU": "DAU/24h",
                "Balance": "Balance",
                "id": "Newest",
                "genre": "Genre",
                "status": "Status",
                "chain": "Blockchain",
                "previous_rank": "Previous Rank",
                "sosial_rank": "Social Rank",
                "F2P": "F2P",
                "AllCategories": "All Categories",
                "reviews": "Reviews",
                "social_score": "Social Score"
            },
            "detail_label": {
                "name": "Name",
                "Transactions_24h": "Tx/24h",
                "Vloume_24h": "Vol/24h",
                "Transactions_7d": "Tx/7d",
                "Vloume_7d": "Vol/7d",
                "DAU": "DAU/24h",
                "Balance": "Balance",
                "max_volume": "Highest",
                "max_total_volume": "Highest",
                "graph": "Tx of week",
                "pv": "Popular",
                "updated_at": "Update",
                "id": "Newest",
                "genre": "Genre",
                "status": "Status",
                "chain": "Blockchain",
                "previous_rank": "Previous Rank",
                "sosial_rank": "Social Rank",
                "F2P": "F2P",
                "price_f2p": "F2P",
                "price_nft": "NFT"
            },
            "tooltip": {
                "name": "Name",
                "Transactions_24h": "Order by Tx/24h",
                "Vloume_24h": "Order by Vol/24h",
                "Transactions_7d": "Order by Tx/7d",
                "Vloume_7d": "Order by Vol/7d",
                "DAU": "Order by DAU",
                "Balance": "Order by Balance",
                "max_volume": "Order by Highest Transaction",
                "max_total_volume": "Order by Highest Player",
                "updated_at": "Sort by new",
                "genre": "Game Genre",
                "status": "Status",
                "previous_rank": "last ranking",
                "total_receiver": "Sort by number of subscribers",
                "price": "Price"
            },
            "sorted_title": {
                "created_at": "Order by Newest.",
                "hotflag": "Order by Hot Dapps",
                "Transactions_24h": "Order by TX /24h",
                "Transactions_7d": "Order by TX /7d",
                "Vloume_24h": "Order by Volume / 24h",
                "Vloume_7d": "Order by Volume / 7d",
                "DAU": "Order by DAU",
                "id": "Order by Newest",
                "Balance": "Order by Balance",
                "max_volume": "Highest Transaction",
                "max_total_volume": "Highest Player",
                "nftart_ranking": "NFTs",
                "genre": "Genre",
                "status": "Status",
                "chain": "Blockchain",
                "previous_rank": "Previous Rank",
                "sosial_rank": "Social Rank",
                "F2P": "F2P",
                "rank": "Blockchain Game Rankings"
            },
            "sorted_description": {
                "created_at": "Ranking order by Newest.",
                "id": "Order by Newest",
                "hotflag": "Ranking order by Hot Dapps",
                "Transactions_24h": "Ranking order by TX /24h",
                "Transactions_7d": "Ranking order by TX /7d",
                "Vloume_24h": "Ranking order by Volume / 24h",
                "Vloume_7d": "Ranking order by Volume / 7d",
                "DAU": "Ranking order by DAU",
                "Balance": "Ranking order by Balance",
                "index": "DApps Ranking order by TX/24h.",
                "max_volume": "Dapps Ranking order by highest transaction by once.",
                "max_total_volume": "Dapps Ranking order by Highest Player.",
                "genre": "Genre",
                "status": "Status",
                "chain": "Blockchain",
                "previous_rank": "Previous Rank",
                "sosial_rank": "Social Rank",
                "F2P": "F2P",
                "rank": "Discover the best blockchain games right now. This ranking is based on the number of blockchain transactions, NFT transactions, and the latest trend information. It provides an instant insight into the most up-to-date and popular blockchain games, offering an enriched gaming experience."
            },
            "sorted_commentary": {
                "created_at": "",
                "hotflag": "",
                "id": "Order by Newest",
                "Transactions_24h": "TX / 24h : Number of 24 hour's Transaction ",
                "Transactions_7d": "TX / 7d : Number of 1 week's transactions.",
                "Vloume_24h": "Volume / 24h : How much Cryptocurrency has arrived at the contractaddress in 24 hour.",
                "Vloume_7d": "Volume / 7d : How much Cryptocurrency has arrived at the contractaddress in 7day.",
                "DAU": "DAU : Number of Unique Address whose submit transaction in 24 hour.",
                "Balance": "Balance : Balance is the total of Cryptocurrency in ContractAddress.",
                "index": "",
                "max_volume": "Max volume : Max volume is most large Amount of Cryptocurrency send to the contractaddress at one transaction.",
                "max_total_volume": "Max total volume : Max total volume is most paid address's volume."
            },
            "display": {
                "ranking": "detail",
                "detail": "list"
            },
            "mydapp_order": {
                "volume": "TotalVolume",
                "max_volume": "MaxVolume",
                "transaction": "Transaction",
                "updated_at": "LastUpdate"
            },
            "searched": "Search by {word}",
            "media": "informations",
            "twitter_name": "Twitter",
            "youtube": "Youtube",
            "medium": "Medium",
            "other": {
                "ranking": "Ranking",
                "game_ranking": "Ranking",
                "review": "Review",
                "rank": "Rank",
                "official_website": "Official Website",
                "new_articles": "New Articles",
                "popular_articles": "Popular Articles",
                "related_articles": "Related Articles",
                "show_more": "Show More",
                "category": "category",
                "genre": "genre",
                "development": "development",
                "chain": "chain"
            },
            "reddit": "Reddit",
            "discord": "Discord",
            "facebook": "Facebook",
            "view": "View Site.",
            "social": "Social Account",
            "contents": {
                "information": "{title} information.",
                "graph_daily": "{title} daily datas.",
                "graph_monthly": "{title} monthly datas.",
                "head": "Contents"
            },
            "data": "{title} Datas",
            "description": "[{title}'s DAU, TX, media informations] {body}",
            "about_game": "{title} Details",
            "game_description": "Description",
            "media_description": "Medias",
            "godata": "Check the graph",
            "wallet_ranking": "Wallet Ranking",
            "register_email": "Please register email for pre-reservation.",
            "pre_reservations": "Pre Reservations",
            "about_newer_bcg_lists": "Click here to see the hottest new blockchaingames (WEB3games)",
            "pre_reserve": {
                "add": "Join PreReserve",
                "remove": "Remove Pre Reserve",
                "reserve_tab": "Pre Reservation",
                "reserve_info": "Pre Reservation",
                "reserve_detail": "Pre Reservation Detail",
                "reservation_lists": "Pre Reservation List",
                "about_reservation_lists": "List of new blockchain games",
                "count": "Number of pre-reserved.",
                "total_count": "Number of total pre-reserved",
                "sale_url": "Landing Page",
                "begin_at": "Start at",
                "company": "Company",
                "on_twitter": "Pre reserved with Twitter",
                "with_twitter": "Join Pre Reserve with Twitter",
                "current_number": "{num} peoples.",
                "reserve_with": "Reserve With",
                "twitter": "Twitter",
                "web": "Email",
                "both": "Twitter and Email",
                "none": "None",
                "updated_at": "Last updated",
                "total_receiver": "Subscribers",
                "id": "New Games",
                "join_caution": "If you join prereserve, you will catch release",
                "about_reservation": "This is a ranking of blockchain games before their official release. Sign up for notifications and receive email alerts."
            },
            "menu": {
                "top": "TOP",
                "game_explanation": "Game Overview",
                "evaluation_review": "Ratings and Reviews",
                "pre_reservation": "Pre Reservation β",
                "chart": "Chart",
                "data": "Data",
                "log": "Log",
                "reviews": "reviews",
                "about_the_game": "Overview",
                "about_the_datas": "Data"
            },
            "login_first": "Please Login or Register first.",
            "caution_pre_register": "If you register pre reservation, We' will send you Release e-mail.",
            "register_email_btn": "Register",
            "reserve_complete": "Reservation completed.",
            "reserve_delete": "Reservation deleted.",
            "activate_sendable": "Agree to change notification setting.",
            "show": {
                "show_more": "Show More",
                "reviews_by_everyone": "Reviews by everyone",
                "no_reviews": "No reviews have been posted yet.",
                "view_all_contract_address": "View all contract addresses"
            },
            "menu_bottom_evaluation_parts": {
                "evaluation": "evaluation",
                "ranking": "ranking",
                "review_count": "Review Count",
                "add_review": "Add Review",
                "edit_review": "Edit Review",
                "required": "Required",
                "rating": "Please select from 1 to 5",
                "nickname": "Nickname",
                "comment": "Comment",
                "play_record": "Play Time",
                "show": "Show",
                "hide": "Hide",
                "play_start_date": "Play Start Date",
                "hours_or_more": "hours or more",
                "recommend_question": "Do you recommend this game?",
                "recommend_action": "Recommend",
                "not_recommend": "Not Recommend",
                "post": "Post"
            },
            "2_0_base": {
                "evaluation": "evaluation",
                "ranking": "ranking",
                "chain": "chain",
                "preview": "preview",
                "go_to_the_official_website": "Go To The Official Website"
            },
            "2_3_category": {
                "category": "category",
                "game_genre": "Game Genre"
            },
            "ranking_v2": {
                "price_free": "Free to Play",
                "price_nft": "Need to NFT",
                "price_unknown": "-"
            },
            "review": {
                "reviews_by_everyone": "Reviews by everyone",
                "no_reviews": "No reviews have been posted yet.",
                "show_more": "Show More",
                "newest_first": "NewestFirst",
                "likes_first": "LikesFirst",
                "rating_and_reviews": "rating_review",
                "votes_counted": "people found this review helpful"
            },
            "review_card": {
                "started_game_date": "Started Game Date",
                "helpful": "Helpful",
                "not_helpful": "Not Helpful",
                "show_more": "Show More"
            },
            "top": {
                "section__title": "Start Your Blockchain Gaming Journey",
                "section__copy1": "\"Blockchain Game Info by GMO\" is ",
                "section__copy2": "an information media for blockchain games.",
                "section__copy3": "We deliver a wide range of content including ",
                "section__copy4": "latest transaction information, game introductions, and strategy articles.",
                "link__title_ranking": "Rankings",
                "link__description_1": "Get the latest trends",
                "link__description_2": "in games and NFTs",
                "link__title_game": "Games",
                "link__description_3": "Discover",
                "link__description_4": "blockchain games",
                "link__title_nft": "NFT",
                "link__description_5": "Check major NFT collections and charts",
                "link__title_news": "News",
                "link__description_6": "Check information on new",
                "link__description_7": "and trending games",
                "link__title_4": "For Beginners",
                "link__description_8": "Learn about blockchain gaming",
                "link__title_5": "My Page",
                "link__description_9": "Manage your owned NFTs and favorite games in one place",
                "link__title_6": "Connect Wallet",
                "register__title_1": "Connect your wallet ",
                "register__title_2": "and check information ",
                "register__title_3": "more conveniently",
                "register__description_1": "You can check the information of the assets you own on My Page. ",
                "register__description_2": "You can check various information such as the price sold",
                "register__description_3": " in the past month and the current lowest price.",
                "register__l": "Connect Wallet",
                "register__r": "Wallet ",
                "register__r_1": "Connection",
                "register__r_2": "View owned NFTs and ",
                "register__r_3": "current game info",
                "register__r_4": "Favorites",
                "register__r_5": "Feature",
                "register__r_6": "Save NFTs and ",
                "register__r_7": "games of interest",
                "register__r_8": "Members-only ",
                "register__r_9": "Information",
                "register__r_10": "Access exclusive info like contract addresses",
                "publisher__lead": "For Game Developers and Publishers",
                "publisher__title": "Want to promote your",
                "publisher__title_1": "project?",
                "publisher__description": "\"Blockchain Game Info by GMO\", Japan's leading platform, can help you gain attention from a wider audience for your game and NFT projects.",
                "publisher__link": "Contact Us for Listing",
                "new_game": "New Games",
                "news_title": "Latest News"
            }
        },
        "auth": {
            "login_with_wallet_or_social": "Login with Wallet or Twitter",
            "login_already_have_an_account": "Already have an account.",
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds.",
            "email": "E-mail Address",
            "password": "Password",
            "login": "Connect",
            "remember_me": "Remember Me",
            "forget_password": "Forget Your Password?",
            "reset_password": "Reset Password",
            "send_password_reset_link": "Password Reset",
            "reset_password_submit": "Reset Password",
            "name": "name",
            "confirm_password": "Confirm Password",
            "register": "Register",
            "register_description": "If you register our site, You can check your favorite dapps!",
            "confirmation_title": "Please confirm your subscription.",
            "agree": "Agree with Attentions.",
            "login_agree": "Read Attentions First.",
            "logout": "Logout",
            "welcome": "You're logged in!",
            "reset_mail_subject": "Reset Password",
            "reset_click_link": "Click link below and reset password.",
            "reset_if_dont": "If you did not request a password reset, no further action is required.",
            "registered": {
                "title": "Completed",
                "description": "The confirmation link was sended. Please activate your account and login .",
                "activate_email": "Please follow the user registration confirmation email to activate your user.",
                "resend_email": "Resend email"
            },
            "select_method": "Select Login method.",
            "connect": "Connect",
            "connect_metamask": "Please connect Wallet first.",
            "connect_first": "Install Metamask, Dapper or Access via ethereum wallet browser.",
            "accept_first": "Connection is not allowed yet.",
            "connect_is_fun": "You can get more information of your assets quickly.",
            "connect_twitter": "Connect Twitter",
            "register_with_address": "Login with Wallet",
            "login_with_twitter": "Login with Twitter Account",
            "login_with_metamask": "Login with Wallet",
            "register_with_email": "Register with Email",
            "nowallet": "There is no connectable wallets. Please access this page from Browser with Metamask, Dapper or Wallet Browser.",
            "whatsmypage": "Informations",
            "whatsup": "If you connect your wallet, you can check your own assets current informations!!",
            "resend": "Resend Confirmation mail",
            "invalid_token": "Invalid Token.",
            "confirm_complete": "Confirmation is completed.",
            "please_login": "Confirmation is completed. Please Login.",
            "already": "You are already the member of BlockchaingameInfo",
            "please_click": "We send you e-mail. Please check the mail and click link for confirmation.",
            "confirm_title": "Confirmation."
        },
        "disclaimer": {
            "title": "Disclaimer",
            "body": "Blockchain Game Info (\"This Website\"hereinafter) is a website operated by GMO Media,Inc. (\"Our Company\"hereinafter).\n\tThis Website does not guarantee accuracy and safety of all posted contents.\n\tAlso, the information on This Website is not intended for soliciting investment in Ethereum or other virtual currencies or other investment.\n\tOur Company will not take any responsibility for any damage incurred based on information on This Website.\n\tIn actual investment, please do not make investment decisions based on the information on This Website, please make a decision on investment at your own discretion."
        },
        "index": {
            "market": "Dapps Market Information",
            "newest": "Newest Article",
            "ranking": "Dapps Volume Ranking",
            "tx_ranking": "Transactions Ranking",
            "pv_ranking": "Dapps favorited Ranking",
            "article": "Dapps Articles",
            "favorite": "Favorites",
            "volume_ranking": "Dapps Volume Ranking",
            "sort_ranking": "Sort Ranking",
            "article_list": "Dapps Articles",
            "article_nextpage": "NextPage",
            "favorite_games": "Favorite Dapps",
            "favorite_games_nextpage": "NextPage",
            "recommend": "Favorited Article",
            "popular_games": "Popular Games",
            "pr": "Promotion Article",
            "readmore": "Read More",
            "dapp": "Most Popular Blockchain Game Ranking",
            "feed": "Feeds List",
            "feedread": "Check Only Your Favorite Dapps Information.",
            "readmoreto": "Read More {name}",
            "ranking_detail": "This Ranking is sort by page views on our site.",
            "more_information": "More Inffomation"
        },
        "mail": {
            "reply": "Thanks for contacting us.",
            "dear": "Hello {name}.",
            "signiture": "<p>\n\t====<br />\n\tBlockchaingameInfo<br />\n\t<a href=\"https://blockchaingame.world/\">BlockchaingameInfo</a><br />\n\tCompany{GMO} Media,Inc<br>\n\tContact：<a href=\"https://blockchaingame.world/contact\">https://blockchaingame.world/contact</a><br>\n\t====<br />\n\t</p>",
            "welcome": "<p>\n\tWelcome!\n\t</p>\n\t<p>\n\tRegistration is completed.<br />\n\tCheck your favorite dapps and assets.<br />\n\tHave a fun!</p>",
            "confirm": "<p>\n\tWelcome.\n\t</p>\n\n\t<p>This is the notice from BlockchaingameInfo<br />\n\tThank you for registration.<br />\n\tPlease click bellow link and activate your account.<br />\n\t</p>\n\t<p>\n\tIf you don't have no recollection of this email, please dispose it.\n\t</p>\n\t"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "side": {
            "profile": {
                "title": "About BlockchainGameInfo",
                "body": "BlockchainGameInfo is blockchain game media. Please send us your dapps."
            },
            "menu": {
                "search_games": "Search Games",
                "filter": "Filter",
                "status": "Status",
                "category": "Category",
                "chain": "Chain",
                "new_games": "New Games",
                "featured_games": "Featured Games",
                "game_ranking": "Game Ranking"
            }
        },
        "user": {
            "home": "Home",
            "joinus": "Connect Wallet and Check Your Assets.",
            "setting": "Settings",
            "if_you_want_to_add": "If you want to add other wallets, just change wallet and connect wallet.",
            "quit": {
                "title": "Quit.",
                "description": "",
                "quit": "Quit BlockchaingameInfo"
            },
            "favorite": "Favorite Games",
            "favorite_feed": "Favorite dApps'es Feeds",
            "add_favorite_and_check_info": "You can check your favorite dApps information, if you add dApps to your Favorite list.",
            "no_favorite_dapps": "There is No Favorited dApps here.",
            "connected_wallets": "ConnectedWallets",
            "connected_information": "Informations",
            "having_assets": "Your Assets List",
            "nextpage": "Next Page",
            "connected_wallets_addresses": "Connected Wallet addresses",
            "connect_metamask": "Add new address",
            "add": "Add",
            "no_connected_wallet": "You have not connected wallet. Please unlock your metamask and add new address.",
            "connected_email": "Email Login informations",
            "disconnect_another": "Please disconnect the wallet from another account.",
            "add_other_login_method_or_quit": "Add other login method.",
            "wallet_was_removed": "The wallet was removed from this account.",
            "connect_wallet_is_interesting": "Connect Your Wallet, you can get the datas of your own Assets.",
            "go_profile": "Go To Connect Wallet Page.",
            "playing_dapps": "Played Dapps",
            "favassets": "Favorite Assets",
            "favdapps": "Favorite Games",
            "playing_history": "playing history",
            "wallet": "Wallet",
            "collection": "Collection",
            "game_reviews": "Game Reviews",
            "profile": "Profile",
            "register_email": {
                "title": "Register email",
                "description": "Activate login vie Email address. Please type your e-mail address and password. we'll send you activate link."
            },
            "change_email_page": {
                "title": "Change Email Address.",
                "description": "If you change your email address, you have to click activation link on our e-mail.<br> <b>Notice: Once you change incorrect email to login information, other people who has incorrect email could login your account.</b>"
            },
            "change_password_title": "change password",
            "change_password_description": "Don't use the same password over and over again.",
            "sendable": "Email notifications",
            "agree": "I agree to receive promotional emails from BCGI",
            "disagree": "I do not consent to receiving emails.",
            "change_email": "Change Email Address and Notification Setting.",
            "change_password": "Change Password",
            "register_email_login": "Register Email Login and Notification.",
            "quit_button": "Quit",
            "all": "All Curator",
            "byuser": "Article Written by {user}",
            "share": "share",
            "tweet": "tweet",
            "gplus": "share",
            "hatena": "share",
            "search": "Search Curator",
            "describe": "This page is introducing Curator that writing on this site",
            "curator": "curator name",
            "created_at": "Recently created at",
            "updated_at": "Recently updated at",
            "desc": "Desc",
            "asc": "Asc"
        },
        "layout": {
            "header": {
                "ranking": "Ranking",
                "ranking_all": "Ranking",
                "column": "News",
                "assets": "Asset Analyzer",
                "favorite": "My Page",
                "search": "Search",
                "login": "Connect",
                "register": "Register",
                "member": "Member",
                "dappfeed": "Official Feeds",
                "dapp_category": "Dapps Category",
                "dapp_status": "Dapps Status",
                "article_category": "News Category",
                "title": "BlockchainGame Info",
                "description": "Ranking,News,Column of Blockchain Games and NFTs",
                "search_genre": {
                    "dapps": "Game",
                    "article": "Article",
                    "assets": "NFT",
                    "keyword": "Search by keyword"
                },
                "send_dapps": "Register dApps",
                "send_press": "Send PR",
                "news_top": "NEWS TOP",
                "nft": "NFTS",
                "game": "GAMES",
                "news": "NEWS",
                "my_page": "My Page"
            }
        },
        "menu": {
            "ranking": "ranking",
            "article": "article",
            "favorite": "favorite",
            "lang": "jap/en",
            "transaction_history": "Transaction History",
            "transaction_info": "Transaction Info",
            "chart": "Chart",
            "nft": "NFT",
            "view_game_details": "View Game Details"
        },
        "error": {
            "403": {
                "title": "Forbidden",
                "body": "You don't have permission to access on this page."
            },
            "404": {
                "title": "Not found.",
                "body": "The requested URL was not found on this server."
            },
            "500": {
                "title": "Internal Service Error",
                "body": "Please Contact Server Administrator."
            },
            "503": {
                "title": "Service Unavailable",
                "body": "Sorry. We're under maintenance."
            }
        },
        "help": {
            "myasset_help_base": "You can check your assets in your wallets.<br>\n\n\t\t\tFirst. you have to add your wallets in Profile page.\n\t\t"
        },
        "blog": {
            "readmore": "readmore",
            "related": "Related Article",
            "sameuser": "Articles written by same user.",
            "sametag": "Articles include same tags.",
            "samecategory": "Articles of {category}",
            "keywords": "Keywords",
            "author": "About Author",
            "share": "Please Share this Article.",
            "before": "Previous Article",
            "next": "Next Article",
            "likeme": "If you like this Article,<br>Push 'Like' button",
            "likeme_after": "We are Updating dApps Informations.",
            "ranking": "Ranking of {category}",
            "content": "Contents",
            "publish_date": "publish date",
            "update_date": "update date",
            "pickup_news": "PickUp News"
        },
        "pre_reservation": {
            "header": "事前通知情報登録",
            "active": "公開",
            "nonactive": "非公開",
            "delete": "削除",
            "updated_at": "更新順",
            "total_receiver": "登録者数順",
            "id": "新着順",
            "botan": {
                "entry": "登録",
                "update": "更新"
            },
            "label": {
                "begin_at": "開始時刻",
                "end_at": "終了時刻",
                "company_ja": "会社名（日本語）",
                "company_en": "会社名（英語）",
                "company_url": "会社URL",
                "begin_ja": "リリース予定（日本語）",
                "begin_en": "リリース予定（英語）",
                "sale_url": "セールページ",
                "sale_text_ja": "特典文言（日本語）",
                "sale_text_en": "特典文言（英語）",
                "sale_image_ja": "特典用画像（日本語）",
                "sale_image_en": "特典用画像（英語）",
                "display": "表示/非表示（論理削除）"
            }
        },
        "web": {
            "app": {
                "disclaimer": "Disclaimer",
                "term": "term of uses",
                "press": "Press",
                "attention": "Attention",
                "policy": "privacy policy",
                "contact": "Contact",
                "japanese": "Japanese",
                "english": "English",
                "informations": "informations",
                "development_lp": "BlockChainGame development",
                "jobs_matching": "BlockChain Jobs matching",
                "commerce": "Notation based on the Act on Specified Commercial Transactions",
                "dapps_entry": "Submit a DApps",
                "author": "BlockChainGame Info",
                "description": "Block chain game information site, ranking and game strategy articles will be sent.",
                "keywords": "Block chain game, Dapp, Dapps ranking, block chain game ranking, Dapp game",
                "caution": ""
            },
            "top": {
                "news_title": "Information",
                "news_index": "Older Informations",
                "blog_title": "Article",
                "blog_index": "Articles"
            },
            "news": {
                "index": "Informations",
                "publish_at": "published at {date}"
            },
            "contact": {
                "index": "Contact us",
                "create": "Confirm",
                "name": "Name",
                "email": "Email Address",
                "tel": "Tell",
                "body": "Message",
                "submit": "Submit",
                "description": "Need help?",
                "preview_title": "Do you really post it?",
                "preview_description": "",
                "stored_title": "Thank you for contact us. We will reply you soonly.",
                "stored_description": "Submited.",
                "send": "submit",
                "ip": "There are limitation by ip address. Please wait a moment.",
                "form": {
                    "name": "Name",
                    "email": "Email",
                    "tel": "Tel",
                    "body": "Message",
                    "submit": "Submit",
                    "confirm": "Confirm",
                    "back": "Back"
                }
            },
            "dapp": {
                "index": "dapps list",
                "other_dapp": "other dapps",
                "related_dapp": "Related Dapps",
                "new_dapps": "New Blockchain Games",
                "similar_dapps": "Similar GameFI",
                "share": {
                    "tweet": "tweet",
                    "facebook": "facebook",
                    "twitter_share": "tweet",
                    "facebook_share": "share",
                    "tweet_hashtag": "blockchaingameinfo"
                },
                "info": {
                    "genre": "Category",
                    "link": "Dapp Website",
                    "balance": "Balance",
                    "volume_24": "Vol/day",
                    "volume_7d": "Vol/7day",
                    "transaction_1h": "Tx/1h",
                    "transaction_24h": "Tx/24h",
                    "transaction_7d": "Tx/7d",
                    "dau": "DAU/24h",
                    "max_volume": "MostExpensive",
                    "max_total_volume": "MostPaidUser",
                    "totalhuman": "TotalPlayer",
                    "human": "Player",
                    "volume": "Volume",
                    "transaction": "Transaction",
                    "detail": "Detail",
                    "mau_this": "this month",
                    "mau_last": "last month",
                    "volume_this": "this month",
                    "volume_last": "last month",
                    "transaction_this": "this month",
                    "transaction_last": "last month",
                    "mau_most": "Biggest MAU",
                    "dau_detail": "DAU: Daily Unique User",
                    "mau_detail": "MAU: Monthly Unique User",
                    "paid_user_detail": "Paid User : Number of people who have tx over 0 eth volume.",
                    "arppu_detail": "ARPPU : Average Revenue per Paid User.",
                    "graph_detail": "This graph is drawn by Japanese time zone.",
                    "nu_detail": "New user is ",
                    "volume_rank": "Daily Volume Ranking",
                    "dau_rank": "Daily DAU Ranking",
                    "none_zero_mau": "this month's Paid User",
                    "none_zero_mau_last": "last month's Paid User",
                    "mnu": "this month's new wallets",
                    "mnu_last": "last month's new wallets",
                    "arppu": "this month's ARPPU",
                    "arppu_last": "last month's ARPPU"
                },
                "graph": {
                    "span": {
                        "chart_long": "Last 7 days",
                        "chart_middle": "Last 2 days",
                        "range_all": "All time",
                        "range_month": "1 month",
                        "range_week": "1 week",
                        "range_day": "1 day"
                    },
                    "description": {
                        "y": "Y-axis ： total of transactions.",
                        "x": "X-axis ： Time.",
                        "caution": "If there is no transaction history within the specified period, graphs may not be displayed."
                    },
                    "title": {
                        "daily": "Daily Data",
                        "monthly": "Monthly Data"
                    }
                },
                "script": {
                    "gas": "GasUsed",
                    "volume": "Vol",
                    "transactions": "TX",
                    "dau": "DAU",
                    "none_zero_dau": "Paid User",
                    "mau": "MAU",
                    "none_zero_mau": "Paid User",
                    "mnu": "New User",
                    "arppu": "ARPPU",
                    "highest": "Highest",
                    "lowest": "Lowest",
                    "average": "Average",
                    "weighted_average_1": "5 days Weighted Average",
                    "weighted_average_2": "25 days Weighted Average",
                    "weighted_average_3": "100 days Weighted Average",
                    "high_and_low": "Highest and Lowest",
                    "total": "Total",
                    "num": "Number"
                },
                "related_article": "Related Article"
            },
            "dappfeed": {
                "index": "Dapp Feeds"
            }
        },
        "dapp_check": {
            "title": "{address}'s {title} Ranking.",
            "volume": "Total Volume",
            "max_volume": "Max Volume",
            "rank_volume": "{rank} th by {whole} ({paid_whole} people was paid)",
            "transactions": "Transactions",
            "playing": "{address} also playing.",
            "view_etherscan": "View on EtherScan",
            "view_opensea": "View on Opensea",
            "top": "{address} is Top!"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "admin": {
            "menu": {
                "site_name": "BCGI",
                "admin_top": "管理画面トップ",
                "notice": "お知らせ管理",
                "dapps": "Dapp",
                "dapp": "Dapp一覧管理",
                "contact": "問い合わせ対応",
                "dapp_hold": "Dappインポート",
                "api_master_chain_list": "MasterAPI一覧",
                "help": "管理画面マニュアル",
                "setting": "サイト設定",
                "content": "コンテンツ管理",
                "analytics": "集計",
                "dapp_crawler": "Dappクローラー新規作成",
                "dapp_crawlers": "Dappクローラ一覧",
                "blockchain_list": "BlockChain一覧",
                "crawler_dapp_setting": "Dappクローラ設定"
            },
            "notice": {
                "create": "お知らせ新規作成",
                "index": "お知らせ一覧",
                "edit": "お知らせ編集",
                "description": "本文へは<br><font><b><strong><h1><h2><h3><h4><h5><dt><dd><ul><li>のタグが使用可能です。"
            },
            "contact": {
                "index": "問い合わせ一覧",
                "edit": "問い合わせ返信",
                "description": "",
                "reply_title": "お問い合わせへの返信"
            },
            "dapp_hold": {
                "index": "Dappインポート一覧"
            },
            "top": "Top",
            "logout": "Log Out",
            "article_setting": "ArticleSetting",
            "articles": "Articles",
            "blog_contents": "Article Contents Setting",
            "user_setting": "User Setting",
            "users": "Users",
            "admins": "Admins",
            "site_settings": "Site Settings",
            "contents": "Content Setting",
            "categories": "Category Setting",
            "tags": "Tags",
            "contacts": "Contacts",
            "settings": "Settings"
        },
        "text": {
            "source": "Source",
            "link1": "Go to website.",
            "link2": "Go to Shopping.",
            "link3": "See detail.",
            "link4": "Buy now.",
            "link5": "Check it now.",
            "link6": "Reserve.",
            "link7": "Contact.",
            "see_more": "See more",
            "substack": {
                "text1": "Receive",
                "text2": "the Latest Updates",
                "text3": "via",
                "text4": "Email",
                "text5": "Get the latest updates on Blockchain Games, GameFi, and NFT news delivered to your inbox."
            },
            "top": {
                "footer_banner1": "Find ",
                "footer_banner2": "the Perfect Blockchain Game for You.",
                "footer_banner3": "Top"
            }
        },
        "image": {
            "numofnum": "{num} of {max} | {title}",
            "thisarticle": "This image is on this article.",
            "readthis": "Read This Article",
            "thisarticleimages": "Images on this Article.",
            "samecate": "Same categories articles.",
            "before": "prev",
            "after": "next",
            "related": "Related Articles"
        },
        "asset": {
            "index": "NFT Price Search",
            "index_token": "{token_name} NFT Price Search",
            "description": "Asset Analyzer is the tool for check NFT Asset's latest sold price.",
            "nums": "{num}",
            "detail": "View detail.",
            "listing_time": "{listing_time} days ago",
            "your_price_on_opensea": "Your Listing Price On Opensea",
            "your_price": "Price",
            "check_asset_on_opensea": "Check NFTs On Opensea",
            "listing_price_on_opensea": "Listing Price On Opensea (Listed in a month)",
            "min_listing_price": "Min Listing Price",
            "max_listing_price": "Max Listing Price",
            "listing_num": "Listing Num",
            "check_listing_assets": "Check Listing NFTs on Opensea",
            "monthly_sold_data": "Monthly Sold Data by AssetAnalyzer",
            "30d_sold_data": "Sales Information for the Last 30 Days",
            "latest_sold": "latest selling price",
            "highest_sold": "Highest Sold",
            "average_sold": "Average Sold",
            "lowest_sold": "Lowest Sold",
            "sold_num": "Sold Num",
            "detail_on_assetanalyzer": "Details on AssetAnalyzer",
            "not_listed": "Not Listed on AssetAnalyzer",
            "trending_in_gaming": "Trending in Gaming",
            "higherthan": "Higher than Highest sold",
            "between_high_ave": "Between Average and Highest sold",
            "between_ave_low": "Between Lowest and Average sold",
            "lowerthan": "Lower than Lowest sold",
            "current_lowest": "Current Lowest listing",
            "shorthand": "ShortHand",
            "longhand": "LongHand",
            "gauge": "Gauge\tPart",
            "addfav": "Add Fav.",
            "removefav": "Remove Fav.",
            "whatsfav": "Click 'add Fav.' button on NFT page. You will get NFT informations like current price, current listing number.",
            "caution_span": "per 1 month.",
            "caution_subtext": "In bracket number is a comparison with data for the past 30 days.",
            "sold_data_30d": "30d",
            "list": "NFT Lists",
            "list_h2": "View NFT Price List",
            "thanks": "This Datas are Provided By",
            "asset_db_title": "Asset Analyzer",
            "token_db_title": "Analysing Tokens",
            "see_on_opensea": "Search on Opensea.",
            "see_on_sorare": "Search on Sorare.",
            "opensea": "Selling on Opensea.",
            "sorare": "Selling on Sorare.",
            "caution_opensea": "This datas got by every two hours.",
            "caution_opensea_token": "Sometimes, it may not narrowed if original tag added.",
            "not_sale": "Not sale now.",
            "title": "{asset}'s data from {dapp}",
            "asset_h2": "Price Trends",
            "thankyou_opensea": "This data is provided by opensea api.",
            "token_title": "{token}'s data from {dapp}",
            "token_title_h1": " token's data",
            "highest_order": "Monthly Highest Sales NFTs",
            "number_order": "Monthly Most Traded NFTs",
            "total_order": "Monthly Hieghest Total Sales NFTs",
            "key_order": "Searching {key}",
            "key_game_order": "Searching {key} from {dapp}",
            "timezone": "Aggregate with UTC timezone -Current Time : {utc}",
            "graph": "Transition",
            "high_total_games": "Monthly Highest Sales NFTs",
            "no_dapps": "No Dapps Played.",
            "description_top": "This page is beta version of NFTs Database. You can check the latest sold price. NFTs Database is corresponding to items with any kind of grades.",
            "players_win_transition": "{wallet}'s Latest Win Transition(Last 20)",
            "players_sell_transition": "{wallet}'s Latest Sell Transition(Last 20)",
            "players_transition": "{wallet}'s Latest Transition(Last month)",
            "caution_players_transition": "This data display only listed token.Excluding Bundle Assets.",
            "transition": "Transition",
            "caution_transition": "Last 100",
            "daily_transition": "Daily transition",
            "total_data": "Datas",
            "total_average": "Average",
            "total_highest": "Highest Price",
            "total_lowest": "Lowest Price",
            "total_number": "Total Number",
            "total_total": "Total Sales",
            "nft_latest_transactions": "Latest NFT Trading Activity",
            "previous_month": "< Previous Month",
            "next_month": "Next Month >",
            "sort_total": "Total Sales",
            "sort_num": "Number of Sales",
            "sort_highest": "Highest Sales",
            "caution_contract": "In some case, winner may be displayed even if smart contract.",
            "caution_bandle": "Bundle transaction is excluded.",
            "show": {
                "date": "Date",
                "average": "Average",
                "num": "Number",
                "num_short": "Number",
                "highest": "Highest",
                "lowest": "Lowest",
                "game": "Title",
                "total": "Total",
                "link_to_dapp": "Check {dapp}",
                "link_to_token": "Check {dapp} token datas",
                "reset": "Not Selected",
                "name": "NFTName",
                "winner": "Winner",
                "price": "price",
                "token": "Token",
                "value": "NFT Value",
                "token_id": "Token ID",
                "now_price": "Price",
                "chain": "Chain",
                "metadata": "Metadata"
            },
            "value_description": "NFT Value is Lowest Price in 7 days or If the NFT has not been traded for 7 days, the last traded price will be displayed.",
            "show_tokens": "Same conditions {token}",
            "search": "Filter by {rarity}",
            "detail_search": "Detail",
            "keyword": "Keyword",
            "checkmore": "View NFT lists",
            "search_key": "Search Keywords",
            "updated": "Last updated is {update}",
            "narrow_search": "Refine Search",
            "narrowed_by": "Narrowed by those keywords",
            "keyisexcluded": "Search by Keyword is now ignored. Only genre,rarity.",
            "token_lists": "Token list",
            "token_ranking": "NFT Ranking",
            "search_caution": "Contract Servant is not available on Opensea yet. On game market, sell and trade data is listed.",
            "checkwallet": "Check my NFTs.",
            "listing_date": "Listing Date",
            "current_price": "Current Price",
            "desc": "Desc",
            "asc": "Asc",
            "share_data": "Share Data",
            "sample_token_id": "SampleTokenID",
            "share_code": "ShareCode",
            "share_detail": "You can copy and paste chart data on your blog or website. check bellow.",
            "share_detail_link": "Detail",
            "dapps_details": "DApps Details",
            "nft_lists": "Collections"
        }
    },
    "ja": {
        "passwords": {
            "password": "パスワードは6文字以上で入力してください。",
            "reset": "パスワードはリセットされました。",
            "sent": "パスワードをリセットするリンクをメールアドレスに送信しました。",
            "token": "このリンクは無効です。",
            "user": "このメールアドレスは登録されていません。"
        },
        "dapp": {
            "head_title": "{title}ゲームデータ情報-取引量、DAU、課金者数グラフと関連記事",
            "hot": "急上昇!",
            "new": "新着!",
            "hot_detail": "24時間以内のブロックチェーンの取引履歴を元に、取引数の上昇があった場合に表示されます。",
            "new_detail": "2週間以内に新規に取引が開始されたDappが表示されます。",
            "ranking": "人気ランキング",
            "ranking_detail": "24時間以内のDapp内取引量の降順となります。",
            "rank": "順位",
            "title": "タイトル",
            "category": {
                "newest": "新着一覧",
                "all": "記事一覧"
            },
            "balance": "残高",
            "lastbalance": "残高",
            "dau": "DAU",
            "lastdau": "DAU/24時間",
            "DAU": "DAU/24時間",
            "twitter": "Twitterを見る",
            "volume_24": "取引量/24時間",
            "volume_7d": "取引量/週",
            "lastvolume24": "取引量/24時間",
            "lastvolume7d": "取引量/週",
            "volume": "取引量",
            "Vloume_24h_ratio": "取引量前日比",
            "transaction": "トランザクション数",
            "transaction_1h": "取引数/時",
            "transaction_24h": "取引数/24時間",
            "transaction_7d": "取引数/週",
            "lasttransactions24h": "取引数/24時間",
            "lasttransactions7d": "取引数/週",
            "rank_title": "1日の取引量の降順",
            "max_volume": "最大取引額",
            "max_total_volume": "最大購入者",
            "title_title": "Title",
            "category_title": "Category",
            "balance_title": "Contract Adressの暗号通貨の残高を合計",
            "dau_title": "１日のトランザクション数の合計",
            "volume_24_title": "１日の取引量の合計",
            "volume_7d_title": "7日間の取引量の合計",
            "transaction_1h_title": "1時間の取引数の合計",
            "transaction_24h_title": "1日の取引数の合計",
            "transaction_7d_title": "7日間の取引数の合計",
            "remove_fav": "お気に入り解除",
            "readmore": "もっと見る",
            "add_fav": "お気に入りに追加",
            "detail": "詳細を見る",
            "more_information": "詳しくはこちら",
            "web": "webサイトを見る",
            "dapps_count": "アプリ数",
            "sortby": "ソートして表示する",
            "category_dapps": "{category}",
            "status_dapps": "{status}",
            "category_dapps_d": "{category}カテゴリーのdAppsを",
            "status_dapps_d": "{status}ブロックチェーンゲームの",
            "index": "ブロックチェーンゲーム(NFTゲーム)一覧",
            "mydappinfo": "ウォレット情報",
            "bcgi_storategy": "ゲーム攻略ガイドへ",
            "ContractAddress": "コントラクトアドレス",
            "sort": {
                "created_at": "新着順",
                "hotflag": "急上昇",
                "Transactions_24h": "取引数",
                "Vloume_24h": "取引量",
                "DAU": "DAU/24h",
                "Balance": "残高",
                "max_volume": "最大取引額",
                "max_total_volume": "最大購入者",
                "pv": "人気順",
                "id": "新着順",
                "updated_at": "更新順",
                "genre": "ジャンル",
                "status": "ステータス",
                "chain": "ブロックチェーン",
                "previous_rank": "前回ランク",
                "sosial_rank": "ソーシャルランク",
                "F2P": "F2P",
                "AllCategories": "全てのカテゴリー",
                "reviews": "レビュー",
                "social_score": "Social Score"
            },
            "detail_label": {
                "name": "ゲーム名",
                "Transactions_24h": "取引数/24h",
                "Vloume_24h": "取引量/24h",
                "Transactions_7d": "取引数/7d",
                "Vloume_7d": "取引量/7d",
                "DAU": "DAU/24h",
                "Balance": "残高",
                "max_volume": "最大取引額",
                "max_total_volume": "最大課金者額",
                "graph": "7日間取引量遷移",
                "pv": "人気順",
                "id": "新着順",
                "updated_at": "更新順",
                "genre": "ジャンル",
                "status": "ステータス",
                "chain": "ブロックチェーン",
                "previous_rank": "前回ランク",
                "sosial_rank": "ソーシャルランク",
                "F2P": "F2P",
                "price_f2p": "基本無料",
                "price_nft": "NFTが必要"
            },
            "sorted_title": {
                "created_at": "新着ブロックチェーンゲーム",
                "id": "新着ブロックチェーンゲーム",
                "hotflag": "急上昇ブロックチェーンゲーム",
                "Transactions_24h": "取引数ランキング",
                "Transactions_7d": "取引数ランキング",
                "Vloume_24h": "取引量ランキング",
                "Vloume_7d": "取引量ランキング",
                "DAU": "DAUランキング",
                "Balance": "残高ランキング",
                "index": "取引量ランキング",
                "max_volume": "最大取引額",
                "max_total_volume": "最大課金者額",
                "pv": "人気ブロックチェーンゲームランキング",
                "updated_at": "更新順ブロックチェーンゲーム",
                "nftart_ranking": "NFTランキング",
                "genre": "ジャンル",
                "status": "ステータス",
                "chain": "ブロックチェーン",
                "previous_rank": "前回ランク",
                "sosial_rank": "ソーシャルランク",
                "F2P": "F2P",
                "rank": "ブロックチェーンゲームランキング"
            },
            "sorted_description": {
                "created_at": "ブロックチェーンの取引情報から集計した結果を登録順にブロックチェーンゲーム（NFTゲーム）、NFT、トークンのランキング表示しています。",
                "hotflag": "ブロックチェーンの取引情報から集計した結果を上昇率によってブロックチェーンゲーム（NFTゲーム）、NFT、トークンのランキング表示しています。",
                "Transactions_24h": "ブロックチェーンの取引情報から集計した結果を24時間の取引数順にブロックチェーンゲーム（NFTゲーム）、NFT、トークンのランキング表示しています。",
                "Transactions_7d": "ブロックチェーンの取引情報から集計した結果を一週間の取引数順にブロックチェーンゲーム（NFTゲーム）、NFT、トークンのランキング表示しています。",
                "Vloume_24h": "ブロックチェーンの取引情報から集計した結果を24時間の取引量順にブロックチェーンゲーム（NFTゲーム）、NFT、トークンのランキング表示しています。",
                "Vloume_7d": "ブロックチェーンの取引情報から集計した結果を一週間の取引量順にブロックチェーンゲーム（NFTゲーム）、NFT、トークンのランキング表示しています。",
                "DAU": "ブロックチェーンの取引情報から集計した結果を一日のDAU順にブロックチェーンゲーム（NFTゲーム）、NFT、トークンのランキング表示しています。",
                "Balance": "ブロックチェーンの取引情報から集計した結果を残高順に表示しています。",
                "index": "ブロックチェーンゲーム（NFTゲーム）、NFT、トークンランキングはブロックチェーンチェーンの取引情報から集計した結果を24時間の取引量順にランキング表示しています。",
                "max_volume": "過去の取引のうち、一回の取引での取引量で並び替えています。",
                "max_total_volume": "これまでの取引者のうち、最大課金者の総額で並び替えています。",
                "pv": "注目ブロックチェーンゲーム（NFTゲーム）、NFT、トークンランキングを、当サイトに訪れたユーザー数順で並び替えています。",
                "updated_at": "ブロックチェーンゲーム（NFTゲーム）、NFT、トークンの情報更新順に並び替えています。",
                "id": "ブロックチェーンゲーム（NFTゲーム）、NFT、トークンの新着順に表示しています。",
                "rank": "ブロックチェーンのトランザクション数、NFT取引数、トレンド情報などを参考に独自のランキング順位を作成しています。"
            },
            "sorted_commentary": {
                "created_at": "",
                "hotflag": "",
                "id": "ブロックチェーンゲーム（NFTゲーム）、NFT、トークンの新着順に表示しています。",
                "Transactions_24h": "ブロックチェーンゲームの取引数とは：ゲームのコントラクトアドレスのスマートコントラクトをユーザーが実行した回数を示します。アセットを購入する、マーケットでトレードする売買の他に、ゲーム内でガス代を使用してスマートコントラクトを実行するイベントもトランザクションに含まれます。",
                "Transactions_7d": "ブロックチェーンゲームの取引数とは：ゲームのコントラクトアドレスのスマートコントラクトをユーザーが実行した回数を示します。アセットを購入する、マーケットでトレードする売買の他に、ゲーム内でガス代を使用してスマートコントラクトを実行するイベントもトランザクションに含まれます。",
                "Vloume_24h": "ブロックチェーンゲームの取引量とは：取引量は、ゲームのコントラクトアドレス宛に直接送られた暗号資産の合計を指します。ゲームで何かの支払いをする場合と、ゲームのマーケットで他のユーザーからアセットを購入する場合などがあります。他のユーザーへ暗号通貨がゲームを通してわたる場合、支払い金額が一度ゲームのコントラクトアドレスを通って、\n\t\t手数料などを引いた額が他のユーザーのウォレットへ送られます。この場合、支払い金額が取引量として加算されます。ほかのユーザーのウォレットに出て行った暗号資産は引かれていません。",
                "Vloume_7d": "ブロックチェーンゲームの取引量とは：取引量は、ゲームのコントラクトアドレス宛に直接送られた暗号資産の合計を指します。ゲームで何かの支払いをする場合と、ゲームのマーケットで他のユーザーからアセットを購入する場合などがあります。他のユーザーへ暗号通貨がゲームを通してわたる場合、支払い金額が一度ゲームのコントラクトアドレスを通って、\n\t\t手数料などを引いた額が他のユーザーのウォレットへ送られます。この場合、支払い金額が取引量として加算されます。ほかのユーザーのウォレットに出て行った暗号資産は引かれていません。",
                "DAU": "ブロックチェーンゲームのDAUとは：ゲームのコントラクトアドレスのスマートコントラクトを実行し、トランザクションを発生させたウォレットの数を指します。ゲームのサイトに実際にアクセスしたユーザーとは異なり、トランザクションを発生させたウォレットの数です。",
                "Balance": "ブロックチェーンゲームの残高とは：ゲームのコントラクトアドレスに現時点で残っている暗号通貨の合計を指します。",
                "index": "ブロックチェーンゲームのDAUとは：ゲームのコントラクトアドレスのスマートコントラクトを実行し、トランザクションを発生させたウォレットの数を指します。ゲームのサイトに実際にアクセスしたユーザーとは異なり、トランザクションを発生させたウォレットの数です。",
                "max_volume": "",
                "max_total_volume": "",
                "pv": "",
                "updated_at": ""
            },
            "tooltip": {
                "name": "ゲーム名",
                "Transactions_24h": "24時間のトランザクション数で並び替える",
                "Vloume_24h": "24時間の取引量で並び替える",
                "Transactions_7d": "一週間のトランザクション数で並び替える",
                "Vloume_7d": "一週間の取引量で並び替える",
                "DAU": "DAUで並び替える",
                "Balance": "残高で並び替える",
                "max_volume": "最大取引額で並び替える",
                "max_total_volume": "これまでの取引者のうち、最も取引額の多い者の額で並び替える。",
                "id": "新着順に並び替える",
                "total_receiver": "登録者数順に並び替える",
                "genre": "ジャンル",
                "status": "ステータス",
                "chain": "ブロックチェーン",
                "previous_rank": "前回ランク",
                "sosial_rank": "ソーシャルランク",
                "price": "価格",
                "F2P": "F2P"
            },
            "display": {
                "ranking": "画像付き表示",
                "detail": "詳細リスト表示"
            },
            "mydapp_order": {
                "volume": "累計取引量",
                "max_volume": "最大取引量",
                "transaction": "取引数",
                "updated_at": "最終更新日"
            },
            "searched": "{word}の検索結果",
            "media": "informations",
            "twitter_name": "Twitter",
            "youtube": "Youtube",
            "medium": "Medium",
            "other_blog": "Other Blog",
            "reddit": "Reddit",
            "discord": "Discord",
            "facebook": "Facebook",
            "view": "View Site.",
            "social": "Social Account",
            "contractaddress": "コントラクトアドレスを確認する",
            "contents": {
                "information": "{title}説明",
                "graph_daily": "{title}日別データ",
                "graph_monthly": "{title}月別データ",
                "head": "目次"
            },
            "data": "{title}データ一覧",
            "description": "[{title}のDAUや取引量グラフ]{body}",
            "about_game": "{title}の詳細情報",
            "game_description": "説明",
            "media_description": "メディア一覧",
            "godata": "グラフ・データを見る",
            "wallet_ranking": "ユーザー別取引量ランキング",
            "register_email": "事前通知にはEmailアドレスを登録してください。",
            "pre_reservations": "新作ブロックチェーンゲーム",
            "about_newer_bcg_lists": "注目の新作ブロックチェーンゲーム（NFTゲーム）はこちらから",
            "pre_reserve": {
                "add": "通知登録",
                "remove": "通知を解除する",
                "reserve_tab": "事前通知",
                "reserve_info": "事前通知情報",
                "reserve_detail": "事前通知詳細",
                "reservation_lists": "事前通知一覧",
                "about_reservation_lists": "注目の新作ブロックチェーンゲーム（NFTゲーム）",
                "count": "通知登録人数",
                "sale_url": "WEBサイト",
                "begin_at": "サービス開始予定",
                "company": "提供/開発会社",
                "on_twitter": "Twitterでの登録数",
                "with_twitter": "Twitterで通知登録",
                "current_number": "{num}人",
                "reserve_with": "事前通知方法",
                "twitter": "Twitter",
                "web": "Email",
                "both": "TwitterかE-mail",
                "none": "無",
                "join_caution": "",
                "updated_at": "更新順",
                "total_receiver": "登録者数順",
                "id": "新着順",
                "about_reservation": "このページでは注目の新作ブロックチェーンゲーム（NFTゲーム）を紹介しています。\n\t\t通知登録を行うとeメールでお知らせを受け取る事が出来ます。"
            },
            "menu": {
                "top": "攻略トップ",
                "game_explanation": "ゲーム説明",
                "evaluation_review": "評価・レビュー",
                "pre_reservation": "事前通知β",
                "chart": "チャート",
                "data": "取引データ",
                "log": "ログ",
                "reviews": "レビュー",
                "about_the_game": "ゲーム概要",
                "about_the_datas": "データ"
            },
            "login_first": "通知の登録を行う際は、先にブロックチェーンゲームインフォへログインをしてください。",
            "caution_pre_register": "通知登録を行うと、登録されたメールアドレスにこのブロックチェーンゲームの通知が届きます。",
            "reserve_complete": "通知登録が完了しました。",
            "reserve_delete": "通知登録を解除しました。",
            "activate_sendable": "メールの通知設定を「配信を受け取る」へ変更する",
            "show": {
                "show_more": "すべてのレビューを見る",
                "reviews_by_everyone": "みんなのレビュー",
                "no_reviews": "まだレビューが投稿されておりません。",
                "view_all_contract_address": "すべてのコントラクトアドレスを見る"
            },
            "menu_bottom_evaluation_parts": {
                "evaluation": "評価",
                "ranking": "ランキング",
                "review_count": "レビュー件数",
                "add_review": "レビューを書く",
                "edit_review": "レビューを更新する",
                "required": "必須",
                "rating": "1〜５から選択してください",
                "nickname": "ニックネーム",
                "comment": "コメント",
                "0": "play_record”=>”プレイ時間",
                "show": "表示する",
                "hide": "非表示",
                "play_start_date": "プレイ開始日",
                "hours_or_more": "時間以上",
                "recommend_question": "このゲームをお勧めしますか？",
                "recommend_action": "お勧めする",
                "not_recommend": "お勧めしない",
                "post": "投稿する"
            },
            "2_0_base": {
                "evaluation": "評価",
                "ranking": "ランキング",
                "chain": "チェーン",
                "preview": "プレビュー",
                "go_to_the_official_website": "公式サイトを見る"
            },
            "2_3_category": {
                "category": "カテゴリー",
                "game_genre": "ゲームジャンル"
            },
            "ranking_v2": {
                "price_free": "無料プレイ",
                "price_nft": "NFTが必要",
                "price_unknown": "-"
            },
            "review": {
                "reviews_by_everyone": "みんなのレビュー",
                "no_reviews": "まだレビューが投稿されておりません。",
                "show_more": "続きを読む",
                "newest_first": "新着順",
                "likes_first": "いいね順",
                "rating_and_reviews": "評価とレビュー",
                "votes_counted": "{count}人がこのレビューが参考になったと投票しました"
            },
            "review_card": {
                "started_game_date": "ゲーム開始日時",
                "helpful": "参考になった",
                "not_helpful": "参考にならなかった",
                "show_more": "続きを読む"
            },
            "other": {
                "ranking": "ランキング",
                "game_ranking": "ゲームランキング",
                "review": "レビュー件数",
                "rank": "位",
                "official_website": "公式サイトはこちら",
                "new_articles": "新着記事",
                "popular_articles": "人気記事",
                "related_articles": "関連記事",
                "show_more": "もっと見る",
                "category": "カテゴリー",
                "genre": "ジャンル",
                "development": "開発状況",
                "chain": "チェーン"
            },
            "top": {
                "section__title": "ブロックチェーンゲームをはじめよう",
                "section__copy1": "「Blockchain Game Info byGMO」は、",
                "section__copy2": "ブロックチェーンゲームの情報メディアです。",
                "section__copy3": "最新の取引情報や、ゲームの紹介や攻略に関する記事など",
                "section__copy4": "幅広いコンテンツを配信しています。",
                "link__title_ranking": "ランキング",
                "link__description_1": "最新のゲーム・NFTの",
                "link__description_2": "トレンドをゲットしよう",
                "link__title_game": "ゲーム",
                "link__description_3": "ブロックチェーンゲーム",
                "link__description_4": "を見つけよう",
                "link__title_nft": "NFT",
                "link__description_5": "主要なNFTコレクションとチャートをチェック",
                "link__title_news": "ニュース",
                "link__description_6": "新作・話題のゲーム情報",
                "link__description_7": "をチェック",
                "link__title_4": "初心者向け",
                "link__description_8": "について学ぼう",
                "link__title_5": "マイページ",
                "link__description_9": "所有NFT・お気に入りゲームをまとめて管理",
                "link__title_6": "ウォレット接続",
                "register__title_1": "ウォレット接続して",
                "register__title_2": "もっと便利に情報を",
                "register__title_3": "チェックしよう",
                "register__description_1": "マイページであなたが持つアセットの情報を確認する事ができます。",
                "register__description_2": "過去一ヶ月の販売された価格や、現在の最安値など、",
                "register__description_3": "様々な情報をチェックできるようになります。",
                "register__l": "ウォレット接続する",
                "register__r": "ウォレット",
                "register__r_1": "接続",
                "register__r_2": "所有NFT・プレイ中",
                "register__r_3": "ゲームの情報を確認",
                "register__r_4": "お気に入り",
                "register__r_5": "機能",
                "register__r_6": "気になるNFT・",
                "register__r_7": "ゲームを登録",
                "register__r_8": "会員限定の",
                "register__r_9": "情報",
                "register__r_10": "コントラクトアドレスなど限定情報をチェック",
                "publisher__lead": "ゲーム開発者・パブリッシャーの方へ",
                "publisher__title": "プロジェクトの情報を",
                "publisher__title_1": "発信しませんか？",
                "publisher__description": "国内最大級の集客力を誇る「Blockchain Game Info byGMO」にゲーム・NFTプロジェクトの情報を掲載して、より多くのユーザーからの関心を獲得しましょう。",
                "publisher__link": "掲載お問い合わせ",
                "news_title": "最新ニュース",
                "new_game": "新作ゲーム"
            }
        },
        "auth": {
            "login_with_wallet_or_social": "ウォレットかTwitterアカウントを用いて登録する",
            "login_already_have_an_account": "既にアカウントを持っている",
            "failed": "ログイン情報が登録されていません。",
            "throttle": "ログインに続けて失敗しています。{seconds}秒後に再度お試しください。",
            "email": "メールアドレス",
            "password": "パスワード",
            "login": "ログイン",
            "remember_me": "ログイン情報を記憶する",
            "forget_password": "パスワードを忘れた場合",
            "reset_password": "パスワードのリセット",
            "send_password_reset_link": "パスワードをリセットする。",
            "name": "お名前",
            "confirm_password": "パスワードの確認",
            "register": "新規登録はこちら",
            "register_description": "BlockchainGame Infoに登録をすると、お気に入りのDappの情報を確認できます。",
            "agree": "注意事項に同意する",
            "login_agree": "注意事項",
            "confirmation_title": "【ブロックチェーンゲームインフォ】登録確認メール",
            "registered": {
                "title": "登録完了",
                "description": "登録が完了しました。<br />アカウントの認証メールを送信しましたので、記載されたリンクへアクセスを行い、アカウントを有効化してください。",
                "activate_email": "ユーザー登録確認メールに従って、ユーザーを有効化してください。",
                "resend_email": "メールを再送する"
            },
            "logout": "ログアウト",
            "select_method": "ログイン方法を選択してください。",
            "connect_metamask": "ブロックチェーンゲームインフォからウォレットへの接続を許可をすることでウォレットのアドレス経由でログインすることができます。",
            "connect": "ウォレットへの接続を許可",
            "connect_first": "メタマスクかDAPPERをインストールしたブラウザからアクセスをするか、ウォレットブラウザからアクセスしてください。",
            "accept_first": "許可がありません",
            "connect_is_fun": "ブロックチェーンゲームインフォにウォレットを接続すると、自分のウォレット内のアセットやゲームにアクセスしやすくなります。",
            "connect_twitter": "Twitterへ接続",
            "register_with_address": "ウォレットでログイン",
            "login_with_twitter": "Twitterでログイン",
            "login_with_metamask": "ウォレットでログイン",
            "register_with_email": "メールアドレスで登録",
            "nowallet": "ウォレットが見つかりません。メタマスクやDapperをインストールしたブラウザか、Ethereum対応のウォレットブラウザからアクセスしてください。",
            "whatsmypage": "マイページで出来る事",
            "whatsup": "マイページでは貴方が持つアセットの情報を確認する事ができます。<br />過去一ヶ月の販売された価格や、現在の最安値など、様々な情報をチェックできるようになります。",
            "resend": "認証メールの再送信",
            "invalid_token": "無効なトークンです。",
            "confirm_complete": "認証が完了しました。引き続きお楽しみください。",
            "please_login": "認証が完了しました。ログインしてください。",
            "already": "すでに会員登録が完了しています。",
            "please_click": "認証用のリンクを送信しました。クリックしてユーザー登録を完了させてください。",
            "confirm_title": "認証メール"
        },
        "disclaimer": {
            "title": "免責事項",
            "body": "Blockchain Game Info（以下、「当ウェブサイト」）は、GMOメディア株式会社（以下、「当社」）が運営するウェブサイトです。\n\t当ウェブサイトは、すべての掲載内容について正確性・安全性を保証するものではありません。\n\tまた、当ウェブサイトの掲載情報は、Ethereumをはじめとする仮想通貨、その他の投資勧誘を目的にしたものではありません。\n\t当ウェブサイトの情報に基づいて被ったいかなる損害についても、当社は一切の責任を負いません。\n\t実際に投資を行う際は、当ウェブサイトの情報に依拠して投資判断を下すことはお控えいただき、投資に関するご決定は皆様ご自身のご判断で行うようお願いいたします。"
        },
        "index": {
            "market": "Dappsマーケット情報",
            "newest": "ニュース・記事",
            "ranking": "ブロックチェーンゲーム(NFTゲーム)ランキング",
            "tx_ranking": "取引数順ランキング",
            "pv_ranking": "ページアクセス数順ランキング",
            "article": "コラム記事",
            "favorite": "お気に入り",
            "volume_ranking": "取引量ランキング",
            "sort_ranking": "ランキングをソートして表示する",
            "article_list": "コラム記事一覧",
            "article_nextpage": "次のページ（コラム記事一覧）",
            "favorite_games": "お気に入りNFTゲーム",
            "favorite_games_nextpage": "次のページ（お気に入り NFTゲーム一覧）",
            "recommend": "人気記事",
            "popular_games": "注目のブロックチェーンゲーム",
            "pr": "PR記事",
            "readmore": "もっと見る",
            "dapp": "注目のブロックチェーンゲーム(NFTゲーム)ランキング",
            "feed": "公式最新情報",
            "readmoreto": "{name}をもっと見る",
            "ranking_detail": "注目のブロックチェーンゲーム(NFTゲーム)ランキングは、ブロックチェーンゲームインフォの各ページのアクセス数をもとに並び替えています。"
        },
        "mail": {
            "reply": "お問い合わせ返信",
            "dear": "{name}様",
            "signiture": "<p>\n\t-----<br />\n\t<br />\n\t<a href=\"https://blockchaingame.jp/\">ブロックチェーンゲームインフォ</a><br />\n\t提供会社：GMOメディア株式会社（GMO Media,Inc.）<br>\n\t住所：東京都渋谷区桜丘町26-1 セルリアンタワー<br>\n\tお問い合わせはこちらから：<a href=\"https://blockchaingame.jp/contact\">https://blockchaingame.jp/contact</a><br>\n\t----<br />\n\t</p>",
            "welcome": "<p>\n\tようこそ。\n\t</p>\n\t<p>\n\t登録が完了しました。<br />\n\tお気に入りのDappsをチェックしましょう。<br />\n\t</p>",
            "confirm": "<p>\n\tようこそ。\n\t</p>\n\n\t<p>【ブロックチェーンゲームインフォ】からのお知らせです。<br />\n\tこの度はご登録ありがとうございます。<br />\n\t以下のリンクをクリックしてアカウントを有効化してください。<br />\n\t</p>\n\t<p>\n\tなお、このメールに覚えがない場合、リンクをクリックせず、このまま削除をしてください。\n\t</p>\n\t"
        },
        "side": {
            "profile": {
                "title": "BlockchainGameInfoとは",
                "body": "BlockchainGameInfo（ブロックチェーンゲームインフォ）はブロックチェーンゲーム(NFTゲーム)やdAppsの最新情報、DAUや取引量のデータを取り扱うメディアです。新しいブロックチェーンゲームの推薦随時お待ちしております。<br />\n\t\t<center>▼ブロックチェーンゲームとは▼</center>"
            },
            "menu": {
                "search_games": "ゲーム検索",
                "fillter": "絞り込み",
                "status": "ステータス",
                "category": "カテゴリー",
                "chain": "チェーン",
                "new_games": "新着ゲーム",
                "featured_games": "おすすめゲーム",
                "game_ranking": "ゲームランキング"
            }
        },
        "user": {
            "home": "Home",
            "setting": "設定",
            "joinus": "自分のアセットを確認",
            "if_you_want_to_add": "ウォレットを追加する場合は、ブロックチェーンゲームインフォにログインしたままウォレットを切り替えて追加ボタンを押してください。",
            "quit": {
                "description": "",
                "title": "退会"
            },
            "favorite": "お気に入りゲーム",
            "favorite_feed": "お気に入りdAppsの最新公式ブログ情報",
            "add_favorite_and_check_info": "現在配信されているお気に入り情報はありません。お気に入りにdAppsを追加すると、お気に入りdAppsだけの最新情報(現在Medium,blogの最新情報をWatchできます。)を確認する事が出来ます。",
            "no_favorite_dapps": "お気に入りに登録されているdAppsはありません。",
            "connected_wallets": "接続中のウォレット",
            "connected_information": "その他の情報",
            "connect_metamask": "現在接続中のウォレットを追加する",
            "add": "このウォレットを追加する",
            "no_connected_wallet": "接続中のウォレットがありません。メタマスクやウォレットブラウザよりウォレットの追加を行ってください。",
            "connected_email": "メールアドレスでのログイン情報",
            "having_assets": "所有中のアセット",
            "disconnect_another": "既にほかのアカウントに紐づいています。\n一度ログアウトをして、同じウォレットでログインし、接続を解除するか、既存のアカウントをご利用ください。既存のアカウントへのログインは、このウォレットアドレスを用いた場合、パスワード不要で行えます。",
            "nextpage": "次のページ",
            "connect_wallet_is_interesting": "ウォレットを接続すると、現在所有するアセットの取引情報などを確認することができます。",
            "go_profile": "ウォレット接続ページへ",
            "playing_dapps": "利用経験のあるブロックチェーンゲーム",
            "playing_history": "ゲーム履歴",
            "favassets": "お気に入りアセット",
            "favdapps": "お気に入りゲーム",
            "game_reviews": "レビューしたゲーム",
            "profile": "プロフィール",
            "wallet": "ウォレット",
            "collection": "コレクション",
            "register_email": {
                "title": "メールアドレスでのログイン情報の登録",
                "description": "メールアドレスを登録すると、メールアドレスとパスワードでログインができるようになります。メールアドレス入力後確認メールをお送りしますので確認メールのリンクをクリックしてください。<br><b>Notice: メールアドレスを変更する際、誤ったメールアドレスを入力してしまうと、誤ったメールアドレスを持つ他の誰かがログインできるようになります。入力間違いにご注意ください。</b>"
            },
            "change_email_page": {
                "title": "メールアドレスの変更",
                "description": "メールアドレスを変更する際、誤ったメールアドレスを入力してしまうと、誤ったメールアドレスを持つ他の誰かがログインできるようになります。入力間違いにご注意ください。"
            },
            "change_password_title": "パスワード変更",
            "change_password_description": "パスワードの使いまわしは避けて下さい",
            "sendable": "メール通知設定",
            "agree": "メール配信を受け取る",
            "disagree": "メール配信を受け取らない",
            "change_email": "メールアドレスの変更と通知の設定変更",
            "change_password": "パスワード変更",
            "register_email_login": "メールアドレスログインの設定と通知の設定",
            "all": "全ライター一覧",
            "byuser": "{user}さんの記事",
            "share": "シェア",
            "tweet": "ツイート",
            "gplus": "シェア",
            "hatena": "シェア",
            "search": "検索",
            "describe": "このページでは、ブロックチェーンゲームインフォのライターを紹介します。",
            "curator": "ライター名",
            "created_at": "登録順",
            "updated_at": "アップデート順",
            "desc": "降順",
            "asc": "昇順"
        },
        "layout": {
            "header": {
                "ranking": "ランキング",
                "ranking_all": "総合ランキング",
                "column": "ニュース・記事",
                "assets": "NFTランキング",
                "favorite": "My Page",
                "search": "さがす",
                "login": "ログイン",
                "register": "新規会員登録",
                "member": "会員情報",
                "dappfeeds": "オフィシャル情報",
                "dapp_category": "Dappsカテゴリー",
                "dapp_status": "Dappsステータス",
                "article_category": "記事カテゴリー",
                "title": "ブロックチェーンゲーム インフォ",
                "description": "ブロックチェーンゲーム、NFTゲーム、BCG、NFTプロジェクトの最新ランキング・ニュース・攻略情報メディア",
                "search_genre": {
                    "dapps": "ゲームをさがす",
                    "article": "記事をさがす",
                    "assets": "NFTをさがす",
                    "keyword": "キーワードで検索"
                },
                "send_dapps": "dApps登録",
                "send_press": "プレスリリース送付",
                "biginner": "初心者向け",
                "news_top": "NEWSトップ",
                "nft": "NFT",
                "game": "ゲーム",
                "news": "ニュース",
                "my_page": "マイページ"
            }
        },
        "menu": {
            "ranking": "ランキング",
            "article": "コラム記事",
            "favorite": "お気に入り",
            "lang": "日本語/英語",
            "transaction_history": "取引履歴",
            "transaction_info": "取引情報",
            "chart": "チャート",
            "nft": "NFT",
            "view_game_details": "ゲームの詳細情報を見る"
        },
        "error": {
            "403": {
                "title": "アクセス権がありません。",
                "body": "このページはアクセス権が必要です。"
            },
            "404": {
                "title": "このページは見つかりません。",
                "body": "アクセスされたURLは見つかりませんでした。"
            },
            "500": {
                "title": "エラー",
                "body": "現在エラーが発生しています。サーバーの管理者までお問い合わせください。"
            },
            "503": {
                "title": "メンテナンス中",
                "body": "現在メンテナンス中です。しばらくお待ちください。"
            }
        },
        "help": {
            "myasset_help_base": "You can check your assets in your wallets.<br>\n\n\t\t\tFirst. you have to add your wallets in Profile page.\n\t\t"
        },
        "blog": {
            "related": "関連記事",
            "sameuser": "この著者による記事",
            "sametag": "同じタグを持つ記事",
            "samecategory": "{category}の記事",
            "keywords": "キーワード",
            "author": "著者について",
            "share": "シェア",
            "before": "前の記事",
            "next": "次の記事",
            "likeme": "この記事が良かったら<br>いいねしよう",
            "likeme_after": "毎日情報を更新しています。",
            "ranking": "{category}ランキング",
            "content": "目次",
            "readmore": "続きを読む",
            "more_information": "詳しくはこちら",
            "publish_date": "公開日",
            "update_date": "更新日",
            "pickup_news": "注目記事"
        },
        "pre_reservation": {
            "header": "事前通知情報登録",
            "active": "公開",
            "nonactive": "非公開",
            "delete": "削除",
            "updated_at": "更新順",
            "total_receiver": "登録者数順",
            "id": "新着順",
            "botan": {
                "entry": "登録",
                "update": "更新"
            },
            "label": {
                "begin_at": "開始時刻",
                "end_at": "終了時刻",
                "company_ja": "会社名（日本語）",
                "company_en": "会社名（英語）",
                "company_url": "会社URL",
                "begin_ja": "リリース予定（日本語）",
                "begin_en": "リリース予定（英語）",
                "sale_url": "セールページ",
                "sale_text_ja": "特典文言（日本語）",
                "sale_text_en": "特典文言（英語）",
                "sale_image_ja": "特典用画像（日本語）",
                "sale_image_en": "特典用画像（英語）",
                "display": "表示/非表示（論理削除）"
            }
        },
        "web": {
            "app": {
                "disclaimer": "免責事項",
                "term": "利用規約",
                "press": "プレスリリースの送付",
                "attention": "注意事項",
                "policy": "プライバシーポリシー",
                "japanese": "日本語",
                "english": "英語",
                "contact": "問い合わせ",
                "informations": "お知らせ",
                "development_lp": "ブロックチェーンゲーム受託開発",
                "jobs_matching": "ブロックチェーン業界求人紹介",
                "commerce": "特定商取引法に基づく表記",
                "dapps_entry": "DApps登録",
                "author": "BlockChainGame Info（ブロックチェーンゲームインフォ）",
                "description": "ブロックチェーンゲーム(NFTゲーム)の総合情報サイト、ランキングや攻略情報を発信します。",
                "keywords": "ブロックチェーンゲーム、NFTゲーム、Dapp、Dappランキング、ブロックチェーンゲームランキング、仮想通貨ゲーム",
                "caution": "【ご注意】\n・「Blockchain Game Info」内で提供される「アセットアナライザーβ版」及びこれに付随するサービス（以下、総称して「当サービス」）は、Etherscan、Ozone Networks, Inc. d/b/a OpenSea 等から情報の提供を受けています。\n・当サービスに掲載されている情報は、ブロックチェーンゲーム(NFTゲーム)のアセット取引に関する判断の参考として、取引一般に関する情報提供を目的とするものであり、取引の勧誘等を目的とするものではありません。\n・当サービスに掲載されている情報には、将来的な出来事に関する予想が含まれていることがありますが、それらの記述はあくまで予想であり、その内容の正確性、信頼性等を保証するものではありません。\n・当社（GMOメディア株式会社）は、当サービスに掲載されている情報に基づいて被ったいかなる損害についても、一切の責任を負いません。\n・取引に関するすべての決定は、利用者ご自身の判断でなさるようにお願いいたします。\n・当サービスにおいて公開されている情報につきましては、営業に利用することはもちろん、第三者へ提供する目的で情報を転用、複製、販売、加工、再利用及び再配信することを固く禁じます。"
            },
            "top": {
                "news_title": "Information",
                "news_index": "過去のお知らせ一覧",
                "blog_title": "新着記事",
                "blog_index": "記事一覧"
            },
            "news": {
                "index": "お知らせ一覧",
                "publish_at": "{date}配信のお知らせ"
            },
            "contact": {
                "index": "お問い合わせ",
                "create": "確認",
                "name": "氏名",
                "email": "メールアドレス",
                "tel": "電話番号",
                "body": "お問い合わせ内容",
                "submit": "お問い合わせ送信",
                "description": "お問い合わせはこちらから。",
                "preview_title": "確認",
                "preview_description": "送信内容をお確かめください。",
                "stored_title": "送信完了",
                "stored_description": "送信完了しました。",
                "send": "問い合わせ",
                "ip": "連投を制限しております。もうしばらくお待ちの上、再度お問い合わせください。",
                "form": {
                    "name": "氏名",
                    "email": "メールアドレス",
                    "tel": "電話番号",
                    "body": "お問い合わせ内容",
                    "submit": "お問い合わせ送信",
                    "confirm": "確認",
                    "back": "戻る"
                }
            },
            "dapp": {
                "index": "ブロックチェーンゲーム(NFTゲーム)一覧",
                "other_dapp": "そのほかのDapps",
                "related_dapp": "関連するDapps",
                "new_dapps": "新着ブロックチェーンゲーム",
                "similar_dapps": "類似のGameFI",
                "share": {
                    "tweet": "tweet",
                    "facebook": "facebook",
                    "twitter_share": "tweet",
                    "facebook_share": "share",
                    "tweet_hashtag": "ブロックチェーンゲームインフォ"
                },
                "info": {
                    "genre": "ジャンル",
                    "link": "webサイトへ",
                    "balance": "残高",
                    "volume_24": "24時間",
                    "volume_7d": "一週間",
                    "transaction_1h": "時",
                    "transaction_24h": "24時間",
                    "transaction_7d": "一週間",
                    "dau": "DAU/24時間",
                    "max_volume": "最大取引額",
                    "max_total_volume": "最大課金者の総額",
                    "totalhuman": "累計利用者数",
                    "human": "利用者数",
                    "volume": "取引量",
                    "transaction": "取引数",
                    "detail": "詳細",
                    "mau_this": "MAU",
                    "mau_last": "先月のMAU",
                    "volume_this": "今月",
                    "volume_last": "先月の取引量",
                    "transaction_this": "今月",
                    "transaction_last": "先月の取引数",
                    "mau_most": "最大のMAU",
                    "dau_detail": "DAU: 一日のユニークユーザー数（重複しないユーザー数）です。",
                    "mau_detail": "MAU: 一ヶ月のユニークユーザー数（重複しないユーザー数）です。",
                    "paid_user_detail": "課金者数: 手数料以外のトランザクションを発生させたユーザー数",
                    "arppu_detail": "ARPPU: 課金者一人あたりの平均課金額",
                    "graph_detail": "本グラフは、日本時間で集計しています。本データはブロックチェーン上に記録されたトランザクションを分析して描画しています。",
                    "volume_rank": "上位日別取引量",
                    "dau_rank": "上位日別利用者数",
                    "none_zero_mau": "今月の課金者数",
                    "none_zero_mau_last": "先月の課金者数",
                    "mnu": "今月の新規数",
                    "mnu_last": "先月の新規数",
                    "arppu": "今月のARPPU",
                    "arppu_last": "先月のARPPU"
                },
                "graph": {
                    "span": {
                        "chart_long": "過去1週間",
                        "chart_middle": "過去2日間",
                        "range_all": "全期間",
                        "range_month": "1ヶ月",
                        "range_week": "1週間",
                        "range_day": "１日"
                    },
                    "description": {
                        "y": "Y軸：取引数の合計",
                        "x": "X軸：時間",
                        "caution": "指定期間内での取引履歴が無い場合など、グラフが表示され無いことがあります。"
                    },
                    "title": {
                        "daily": "日別データ",
                        "monthly": "月別データ"
                    }
                },
                "script": {
                    "gas": "Gas合計",
                    "volume": "取引量",
                    "transactions": "取引数",
                    "dau": "DAU",
                    "none_zero_dau": "課金者数",
                    "mau": "MAU",
                    "mnu": "新規数",
                    "none_zero_mau": "課金者数",
                    "arppu": "ARPPU",
                    "average": "平均取引額",
                    "high_and_low": "最高値と最安値",
                    "highest": "最高値",
                    "lowest": "最安値",
                    "weighted_average_1": "5日加重平均",
                    "weighted_average_2": "25日加重平均",
                    "weighted_average_3": "100日加重平均",
                    "total": "合計取引額",
                    "num": "取引数"
                },
                "related_article": "関連記事"
            },
            "dappfeed": {
                "index": "Dapp情報一覧"
            }
        },
        "dapp_check": {
            "title": "{address}さんの{title}利用状況",
            "volume": "累計取引量",
            "max_volume": "最大取引量",
            "rank_volume": "{rank}位/{whole}人（うち課金者{paid_whole}人）",
            "transactions": "取引数",
            "playing": "{address}さんがプレイしたブロックチェーンゲーム(NFTゲーム)",
            "view_etherscan": "EtherScanで確認する",
            "view_opensea": "Openseaで確認する",
            "top": "{address}さんはトッププレイヤーです"
        },
        "validation": {
            "accepted": "{attribute}を承認してください。",
            "active_url": "{attribute}は正しいURLではありません。",
            "after": "{attribute}は{date}以降の日付にしてください。",
            "alpha": "{attribute}は英字のみにしてください。",
            "alpha_dash": "{attribute}は英数字とハイフンのみにしてください。",
            "alpha_num": "{attribute}は英数字のみにしてください。",
            "array": "{attribute}は配列にしてください。",
            "before": "{attribute}は{date}以前の日付にしてください。",
            "between": {
                "numeric": "{attribute}は{min}〜{max}までにしてください。",
                "file": "{attribute}は{min}〜{max} KBまでのファイルにしてください。",
                "string": "{attribute}は{min}〜{max}文字にしてください。",
                "array": "{attribute}は{min}〜{max}個までにしてください。"
            },
            "boolean": "{attribute}はtrueかfalseにしてください。",
            "confirmed": "{attribute}は確認用項目と一致していません。",
            "date": "{attribute}は正しい日付ではありません。",
            "date_format": "{attribute}は\"{format}\"書式と一致していません。",
            "different": "{attribute}は{other}と違うものにしてください。",
            "digits": "{attribute}は{digits}桁にしてください",
            "digits_between": "{attribute}は{min}〜{max}桁にしてください。",
            "email": "{attribute}を正しいメールアドレスにしてください。",
            "filled": "{attribute}は必須です。",
            "exists": "選択された{attribute}は正しくありません。",
            "image": "{attribute}は画像にしてください。",
            "in": "選択された{attribute}は正しくありません。",
            "integer": "{attribute}は整数にしてください。",
            "ip": "{attribute}を正しいIPアドレスにしてください。",
            "max": {
                "numeric": "{attribute}は{max}以下にしてください。",
                "file": "{attribute}は{max} KB以下のファイルにしてください。.",
                "string": "{attribute}は{max}文字以下にしてください。",
                "array": "{attribute}は{max}個以下にしてください。"
            },
            "mimes": "{attribute}は{values}タイプのファイルにしてください。",
            "min": {
                "numeric": "{attribute}は{min}以上にしてください。",
                "file": "{attribute}は{min} KB以上のファイルにしてください。.",
                "string": "{attribute}は{min}文字以上にしてください。",
                "array": "{attribute}は{min}個以上にしてください。"
            },
            "not_in": "選択された{attribute}は正しくありません。",
            "numeric": "{attribute}は数字にしてください。",
            "regex": "{attribute}の書式が正しくありません。",
            "required": "{attribute}は必須です。",
            "required_if": "{other}が{value}の時、{attribute}は必須です。",
            "required_with": "{values}が存在する時、{attribute}は必須です。",
            "required_with_all": "{values}が存在する時、{attribute}は必須です。",
            "required_without": "{values}が存在しない時、{attribute}は必須です。",
            "required_without_all": "{values}が存在しない時、{attribute}は必須です。",
            "same": "{attribute}と{other}は一致していません。",
            "size": {
                "numeric": "{attribute}は{size}にしてください。",
                "file": "{attribute}は{size} KBにしてください。.",
                "string": "{attribute}{size}文字にしてください。",
                "array": "{attribute}は{size}個にしてください。"
            },
            "string": "{attribute}は文字列にしてください。",
            "timezone": "{attribute}は正しいタイムゾーンをしていしてください。",
            "unique": "{attribute}は既に存在します。",
            "url": "{attribute}を正しい書式にしてください。",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "rating": {
                    "required": "評価は必須です。",
                    "integer": "評価は数値で入力してください。",
                    "between": "評価は 1 ~ 5 の数値で入力してください。"
                },
                "checked_played_time": {
                    "required": "プレイ時間を表示させますか？を選択してください。",
                    "numeric": "プレイ時間を表示させますか？の選択は数値で行ってください。",
                    "in": "プレイ時間を表示させますか？の選択が無効です。"
                },
                "played_date": {
                    "required_if": "開始日を入力してください。"
                },
                "played_time": {
                    "required_if": "プレイ時間を入力してください。"
                }
            },
            "attributes": []
        },
        "admin": {
            "menu": {
                "site_name": "BCGI",
                "admin_top": "管理画面TOP",
                "notice": "お知らせ管理",
                "dapps": "Dapp",
                "dapp": "Dapp一覧管理",
                "contact": "問い合わせ対応",
                "dapp_hold": "Dappインポート",
                "api_master_chain_list": "MasterAPI一覧",
                "help": "管理画面マニュアル",
                "setting": "サイト設定",
                "content": "コンテンツ管理",
                "analytics": "集計",
                "media": "メディア確認",
                "user": "ユーザー",
                "dapp_crawler": "Dappクローラー新規作成",
                "dapp_crawlers": "Dappクローラ一覧",
                "blockchain_list": "BlockChain一覧",
                "crawler_dapp_setting": "Dappクローラ設定"
            },
            "notice": {
                "create": "お知らせ新規作成",
                "index": "お知らせ一覧",
                "edit": "お知らせ編集",
                "description": "本文へは<br><font><b><strong><h1><h2><h3><h4><h5><dt><dd><ul><li>のタグが使用可能です。"
            },
            "dapp": {
                "create": "Dapp新規作成",
                "index": "Dapp一覧",
                "edit": "Dapp編集",
                "description": ""
            }
        },
        "text": {
            "source": "出典",
            "link1": "リンクページを見る",
            "link2": "販売ページに行く",
            "link3": "詳細を見る",
            "link4": "購入する",
            "link5": "今すぐチェックする",
            "link6": "予定を入れる",
            "link7": "問い合わせる",
            "see_more": "もっと見る",
            "substack": {
                "text1": "メールで",
                "text2": "最新情報",
                "text3": "を",
                "text4": "受け取ろう",
                "text5": "ブロックチェーンゲーム/GameFi/NFT情報の最新情報をお届けします。"
            },
            "top": {
                "footer_banner1": "あなたにぴったりの",
                "footer_banner2": "ブロックチェーンゲームを見つけよう。",
                "footer_banner3": "ゲームTOPへ"
            }
        },
        "image": {
            "numofnum": "{title} | {max}枚中{num}枚目の画像",
            "thisarticle": "この画像の記事を読む",
            "readthis": "記事を読む",
            "thisarticleimages": "この記事に含まれる画像",
            "samecate": "同じカテゴリーの記事",
            "before": "前",
            "after": "次",
            "related": "関連記事"
        },
        "asset": {
            "index": "NFT現在価格【リアルタイム】",
            "index_token": "{token_name} NFT現在価格【リアルタイム】",
            "description": "ブロックチェーンゲーム(NFTゲーム)で使用されるNFTの売却価格推移、取引件数を確認するツールです。NFT名の検索もできます。",
            "nums": "{num}回",
            "listing_time": "{listing_time}日前",
            "your_price_on_opensea": "Openseaへの出品価格",
            "your_price": "価格",
            "check_asset_on_opensea": "Openseaで表示",
            "listing_price_on_opensea": "このNFTの出品中情報 (一ヶ月以内の出品)",
            "min_listing_price": "最低出品価格",
            "max_listing_price": "最高出品価格",
            "listing_num": "現在も出品中の個数",
            "check_listing_assets": "OpenseaでNFT一覧を見る",
            "monthly_sold_data": "月間販売情報",
            "30d_sold_data": "30日間取引",
            "highest_sold": "最高販売価格",
            "average_sold": "平均販売価格",
            "lowest_sold": "最低販売価格",
            "latest_sold": "最新販売価格",
            "sold_num": "販売個数",
            "detail_on_assetanalyzer": "アセットアナライザーで確認",
            "not_listed": "アセットアナライザーでは取り扱っていないNFTです。",
            "trending_in_gaming": "ゲームのトレンド",
            "higherthan": "最高販売価格以上",
            "between_high_ave": "最高販売価格と平均販売価格の間",
            "between_ave_low": "最低販売価格と平均販売価格の間",
            "lowerthan": "最低販売価格以下",
            "current_lowest": "現在の最低出品価格",
            "shorthand": "短針",
            "longhand": "長針",
            "gauge": "ゲージ部分",
            "addfav": "お気に入りに追加",
            "removefav": "お気に入り解除",
            "whatsfav": "NFTのページにある「お気に入りに追加」ボタンを押すと、このページで最低価格や現在出品中のNFTの情報をチェックできます。",
            "detail": "詳細を見る",
            "caution_span": "※{span}～本日まで",
            "sold_data_30d": "30d",
            "caution_subtext": "()は過去ひと月との比較です。",
            "list": "NFTリスト",
            "list_h2": "のNFT 価格一覧を見る",
            "thanks": "Provided By",
            "asset_db_title": "アセットアナライザー",
            "token_db_title": "アセットアナライザー取り扱いNFT",
            "see_on_opensea": "Openseaで探す",
            "see_on_sorare": "Sorareで探す",
            "opensea": "Openseaで販売中のNFT",
            "sorare": "Sorareで販売中のNFT",
            "caution_opensea": "数時間おきにデータを取得しています。既に販売終了している場合があります。",
            "caution_opensea_token": "ブロックチェーンゲームインフォ独自のタグが設定されている場合、販売中のNFTとして表示されない場合があります。",
            "not_sale": "販売中のNFTはありません。",
            "title": "{asset}の取引価格推移・相場情報 {dapp}",
            "asset_h2": "の取引価格",
            "thankyou_opensea": "本データの作成にはOpenseaのAPIを用いています。",
            "token_title": "{token} のNFT価格一覧",
            "token_title_h1": "のNFT価格一覧",
            "highest_order": "価格順NFTランキング",
            "number_order": "取引回数順NFTランキング",
            "total_order": "合計取引額順NFTランキング",
            "key_order": "{key}の検索結果",
            "key_game_order": "{dapp}内{key}の検索結果",
            "high_total_games": "総取引額順NFTランキング",
            "timezone": "UTC時刻で集計（現在{utc}）",
            "graph": "取引価格推移",
            "no_dapps": "プレイ中のブロックチェーンゲームはありません。",
            "description_top": "アセットアナライザーはNFTの取引データを収集し分析・提示するNFT検索ツールです。本機能はβ版です。ブロックチェーンゲームや、アート系NFTの価格調査等にご利用ください。",
            "players_sell_transition": "{wallet}の最近の売却取引状況(直近20件)",
            "players_win_transition": "{wallet}の最近の購入取引状況(直近20件)",
            "players_transition": "{wallet}の最近の購買取引状況（直近1ヶ月）",
            "caution_players_transition": "このデータはアセットアナライザーに登録されているトークンのみを対象に掲載されます。また、バンドルでの購入は現在対象外になっています。",
            "transition": "取引状況",
            "caution_transition": "※直近100件",
            "daily_transition": "日毎の取引状況",
            "total_data": "全期間の取引データ",
            "total_average": "平均値",
            "total_highest": "最高値",
            "total_lowest": "最安値",
            "total_number": "取引回数",
            "total_total": "合計取引額",
            "previous_month": "< 前月",
            "next_month": "翌月 >",
            "sort_total": "合計値順",
            "sort_num": "取引回数順",
            "nft_latest_transactions": "最近の取引",
            "sort_highest": "最高値順",
            "caution_contract": "購入者の欄に、中継するスマートコントラクトが表示されている場合があります。",
            "caution_bandle": "集計には、BUNDLEでの取引は除外されています。",
            "show": {
                "date": "日付",
                "average": "平均",
                "num": "回数",
                "num_short": "数",
                "highest": "最高",
                "lowest": "最安",
                "game": "ゲーム名",
                "total": "合計",
                "link_to_dapp": "{dapp}を見る",
                "link_to_token": "{dapp}を見る",
                "reset": "未選択",
                "name": "アセット名",
                "winner": "購入者",
                "price": "取引価格",
                "token": "トークン",
                "value": "現在の価値",
                "token_id": "Token ID",
                "now_price": "価格",
                "chain": "チェーン",
                "metadata": "メタデータ"
            },
            "value_description": "現在の価値は、7日間の最安値か、7日間取引が無い場合は最後の取引価格が反映されます。",
            "show_tokens": "同条件の{token}",
            "search": "{rarity}で絞り込む",
            "keyword": "キーワード",
            "checkmore": "NFT一覧を見る",
            "detail_search": "詳細検索",
            "search_key": "キーワード",
            "updated": "{update}更新",
            "narrow_search": "絞り込み検索",
            "narrowed_by": "絞り込み条件",
            "keyisexcluded": "※キーワードは絞り込みから現在除外されています。",
            "token_lists": "{token}のNFT一覧",
            "token_ranking": "NFTランキング",
            "search_caution": "※コントラクトサーヴァント、Sorareのデータはゲーム内マーケット(トレード・セールを含む)のデータを反映しています。",
            "checkwallet": "自分のアセットを確認",
            "listing_date": "リスティングされた日付順",
            "current_price": "価格順",
            "desc": "降順",
            "asc": "昇順",
            "share_data": "共有データ",
            "sample_token_id": "トークンID指定例",
            "share_code": "共有コード",
            "share_detail": "上記コードをブログやウェブサイトに貼り付けることで、このNFTの過去３０日分のチャートを表示することができます。APIについては下記をごらんください。",
            "share_detail_link": "アセットアナライザーAPIについて",
            "dapps_details": "DApps詳細",
            "nft_lists": "コレクション"
        }
    }
}
